import React from 'react'

const Error = ({ message }) => (
    <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: 'white', background: 'red', display: 'flex', justifyContent: 'center', margin: '1rem 1rem 1rem 1rem', padding: '1rem 1rem 1rem 1rem' }}>
        {message}
    </div>
)

export default Error